import React from 'react'
import { compose, lifecycle, branch, renderComponent } from 'recompose'
import { withRouter, Link } from 'react-router-dom'
import { Menu, Grid, Image, Icon, Dropdown, Button, Container, Modal } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { logout } from 'Features/auth/actions'
import { getIsLoggedIn } from 'Features/auth/selectors'
import { getSettings } from '../../rooms/selectors'
import { findDefaultSetting, clearStateFormSearchName } from '../../rooms/actions'
import CustomModel from '../../ui/components/Model/Report'
import { sendReport } from '../../user/actions'
import { getUserInfo, getHasSendReport } from '../../user/selectors'
// import Loading from 'Features/ui/components/Loading'
import ErrorMessage from 'Features/ui/components/ErrorMessage'
import { getIsLoading, getHasError } from '../selectors'
import { getfullName, clearBSRSToken, clearToken } from 'Lib'
import { getAllToken } from "../../../lib/auth"
// import Routes from './Routes'

const H3 = {
	color: "#fff",
	padding: "10px",
	position: "relative",
	width: '100%'
}

// const gridMenuStyle = {
// 	backgroundColor: '#010101',
// 	color: '#fff',
// 	padding: '0',
// 	textAlign: 'center',
// 	marginTop: '-10px',
// }


// const Border = {
// 	color: '#fff',
// 	padding: '10px',
// 	height: '30px',
// }

// const BorderWithGrayBackground = {
// 	backgroundColor: '#9DC2E1',
// 	color: '#fff',
// 	padding: '10px',
// 	height: '30px',
// }
const MenuConst = (props) => {
	const home = () => {
		// props.clearStateFormSearchName()
		window.location.replace(`/`)
	}
	const userManual = (userManualLink) => {
		if (!userManualLink.toString().toLowerCase().startsWith("http://") &&
			!userManualLink.toString().toLowerCase().startsWith("https://")) {
			window.location = `https://${userManualLink.toString().trim()}`
		}
		else window.location = userManualLink.toString().trim()
	}
	const logout = () => {
		clearToken()
		clearBSRSToken()
		props.history.replace(`/login`)
	}
	return (
		<Grid.Row style={{ padding: 0, display: 'inline-flex' }}>
			<Grid.Column style={{ padding: 0 }} width={2}>
				<Menu.Item
					// as={Link} to='/home'
					onClick={() => home()}
					style={{ padding: '5px', margin: 0 }}>
					<Image
						size='tiny'
						src='/assets/images/logo_01.png'
						style={{ height: '45px', width: 'auto' }}
					/>
				</Menu.Item>
			</Grid.Column>
			<Grid.Column style={{ padding: 0 }} computer={3} tablet={10} mobile={7}>
				<Menu.Item style={{ textAlign: 'center' }}>
					{/* <h2 style={head}>{props.moduleName}</h2> */}
				</Menu.Item>
			</Grid.Column>
			<Grid.Column style={{ position: 'absolute', right: 0 }} computer={2} tablet={3} mobile={4}>
				<Menu.Menu position='right'>
					<Dropdown item icon='list ul' className="font20px" style={{ color: '#fff', paddingRight: 0 }} size="big" >
						<Dropdown.Menu style={{ left: '-150px' }}>
							<Dropdown.Item as={Link} to='/information'>
								<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='user' style={{ margin: 0, padding: '5px 15px' }} /> User Information
								</Button>
							</Dropdown.Item>
							<Dropdown.Item as={Link} to='/viewterm' >
								<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='info' style={{ margin: 0, padding: '5px 15px' }} />Term & Condition
								</Button>
							</Dropdown.Item>
							<Dropdown.Item as={Link} to='/floorplan' >
								<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='building outline' style={{ margin: 0, padding: '5px 15px' }} /> Floor Plan
								</Button>
							</Dropdown.Item>
							{
								props.setting.userManualLink &&
								<Dropdown.Item
									onClick={() => userManual(props.setting.userManualLink)}
								>
									<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
										<Icon name='book' style={{ margin: 0, padding: '5px 15px' }} /> User Manual
									</Button>
								</Dropdown.Item>
							}
							<Dropdown.Item
								onClick={logout}
							>
								<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='sign out alternate' style={{ margin: 0, padding: '5px 15px' }} /> Logout
								</Button>
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
					<Dropdown item icon='phone' className="font20px" style={{ color: '#fff' }} size="big">
						<Dropdown.Menu>
							<Dropdown.Item>
								<Button href={`tel:${props.setting.technicalPhoneNumber}`} style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='briefcase' style={{ margin: 0, padding: '5px 15px' }} /> Technical Support
								</Button>
							</Dropdown.Item>
							<Dropdown.Item>
								<Button href={`tel:${props.setting.housekeeperPhoneNumber}`} style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
									<Icon name='bell' style={{ margin: 0, padding: '5px 15px' }} /> Housekeeper
								</Button>
							</Dropdown.Item>
							{
								getfullName() !== undefined && <Dropdown.Item onClick={() => props.openModal()}>
									<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
										<Icon name='clipboard' style={{ margin: 0, padding: '5px 15px' }} /> Report Administrator
									</Button>
								</Dropdown.Item>
							}
						</Dropdown.Menu>
					</Dropdown>
				</Menu.Menu>
			</Grid.Column>
		</Grid.Row>
	)
}

const MenuConstWithOut = (props) => {
	const home = () => {
		// props.clearStateFormSearchName()
		window.location.replace(`/`)
	}
	return (
		<Grid.Row style={{ padding: 0, display: 'inline-flex' }}>
			<Grid.Column style={{ padding: 0 }} width={2}>
				<Menu.Item
					// as={Link} to='/home'
					onClick={() => home()}
					style={{ padding: '5px', margin: 0 }}>
					<Image
						size='tiny'
						src='/assets/images/logo_01.png'
						style={{ height: '45px', width: 'auto' }}
					/>
				</Menu.Item>
			</Grid.Column>
		</Grid.Row>
	)
}

const width100 = { width: '100%', textAlign: 'center' }

class Header extends React.Component {
	constructor(props) {
		super(props)
		let sendReport = false
		if (typeof props.hasSendReport !== 'undefined') {
			if (typeof props.hasSendReport[0] !== 'undefined')
				sendReport = props.hasSendReport[0]
		}

		this.state = {
			open: false,
			title: "",
			modal: {
				open: false,
			},
			sendReport: sendReport,

			isOpenModal: false,
		}
	}
	show = () => this.setState({ open: true })

	openModal = () => {
		// this.setState({
		// 	sendReport: [],
		// 	open: true,
		// 	modal: {
		// 		open: true,
		// 		action: (body) => this.props.sendReport(body)
		// 	}
		// })
		this.setState({
			isOpenModal: true
		})
	}

	close = () => {
		this.setState({
			open: false,
			sendReport: false
		})
	}

	closeReport = () => {
		this.setState({
			open: false,
			sendReport: false
		})
		window.location.reload()
	}

	componentWillReceiveProps(props) {
		if (props.hasSendReport.length > 0) {
			this.setState({
				sendReport: true,
				modal: {
					open: false,
				},
			})
		}
	}

	render() {
		// const { props } = this
		// const { userInfo } = props
		let props = this.props
		const { isOpenModal } = this.state
		return (
			<div id="header">
				{
					this.state.sendReport && props.keyword &&
					<Modal open={this.state.sendReport} onClose={this.close} >
						<Modal.Header>Information</Modal.Header>
						<Modal.Content>
							<Modal.Description>
								Your report has been sent to administrator.
							</Modal.Description>
						</Modal.Content>
						<Modal.Actions>
							<Button color="blue" onClick={() => this.closeReport()}>Ok</Button>
						</Modal.Actions>
					</Modal>
				}
				{
					isOpenModal &&
					<CustomModel onClose={() => this.setState({ isOpenModal: false })} />
				}
				{
					getAllToken().access_token !== undefined ?
						<div>
							{
								props.keyword === "withName" &&
								<Menu secondary fixed='top' id="headerStyle" >
									<div style={{ width: '100%', margin: 0 }}>
										<Container style={{ position: 'relative' }}>
											<MenuConst moduleName={props.moduleName} {...props} {...this} />
										</Container>
									</div>
								</Menu>
							}
							{
								props.keyword === "withoutLogo" &&
								<Menu.Menu style={width100}>
									<Menu.Item style={width100}>
										<h3 style={H3}>{props.moduleName}</h3>
									</Menu.Item>
								</Menu.Menu>
							}
							{
								props.keyword === "onlyLogo" &&
								<Menu secondary fixed='top' id="headerStyle" >
									<div style={{ width: '100%', margin: 0 }}>
										<Container style={{ position: 'relative' }}>
											<MenuConstWithOut moduleName={props.moduleName} {...props} {...this} />
										</Container>
									</div>
								</Menu>
							}
							{
								props.keyword === "withBack" &&
								<Grid style={{ width: '100%', margin: 0 }}>
									<Grid.Row style={{ padding: 0, width: '100%' }}>
										<Grid.Column width={2}>
											<Menu.Item as={Link} to={`/${props.backLink}`}>
												<Icon disabled name='chevron left' size='large' style={{ color: '#fff', marginTop: '8px' }} />
											</Menu.Item>
										</Grid.Column>
										<Grid.Column width={12}>
											<Menu.Item style={width100}>
												<h3 style={H3}>{props.moduleName}</h3>
											</Menu.Item>
										</Grid.Column>
									</Grid.Row>
								</Grid>
							}
							{/* {
								props.keyword === "withCalendar" &&
								<Menu secondary fixed='top' id="headerStyle" style={{ height: '100px' }} >
									<div style={{ width: '100%', margin: 0 }}>
										<Container style={{ position: 'relative' }}>
											<Grid.Row style={{ padding: 0, display: 'inline-flex' }}>
												<Grid.Column style={{ padding: 0 }} width={2}>
													<Menu.Item as={Link} to='/' style={{ padding: '5px', margin: 0 }}>
														<Image
															size='tiny'
															src='/assets/images/logo_01.png'
															style={{ height: '45px', width: 'auto' }}
														/>
													</Menu.Item>
												</Grid.Column>
												<Grid.Column style={{ padding: 0 }} computer={3} tablet={10} mobile={7}>
													<Menu.Item style={{ textAlign: 'center' }}>
														<h2 style={head}>{props.moduleName}</h2>
													</Menu.Item>
												</Grid.Column>
												<Grid.Column style={{ position: 'absolute', right: 0 }} computer={2} tablet={3} mobile={4}>
													<Menu.Menu position='right'>
														<Dropdown item icon='list ul' className="font20px" style={{ color: '#fff', paddingRight: 0 }} size='big' >
															<Dropdown.Menu style={{ left: '-150px' }}>
																<Dropdown.Item>
																	<Button as={Link} to='/information' style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='user' style={{ margin: 0, padding: '5px 15px' }} /> User information
        											</Button>
																</Dropdown.Item>
																<Dropdown.Item>
																	<Button as={Link} to='/viewterm' style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='info' style={{ margin: 0, padding: '5px 15px' }} />Term & Condition
        											</Button>
																</Dropdown.Item>
																<Dropdown.Item>
																	<Button as={Link} to='/floorplan' style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='building outline' style={{ margin: 0, padding: '5px 15px' }} /> Floor Plan
        											</Button>
																</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
														<Dropdown item icon='phone' className="font20px" style={{ color: '#fff' }} size='big' >
															<Dropdown.Menu>
																<Dropdown.Item>
																	<Button href={`tel:${props.setting.technicalPhoneNumber}`} style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='briefcase' style={{ margin: 0, padding: '5px 15px' }} /> Technical Support
        											</Button>
																</Dropdown.Item>
																<Dropdown.Item>
																	<Button href={`tel:${props.setting.housekeeperPhoneNumber}`} style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='bell' style={{ margin: 0, padding: '5px 15px' }} /> Housekeeper
        											</Button>
																</Dropdown.Item>
																{getfullName() !== undefined && <Dropdown.Item onClick={() => this.openModal()}>
																	<Button style={{ borderRadius: '50%', padding: '10px', backgroundColor: '#fff' }}>
																		<Icon name='clipboard' style={{ margin: 0, padding: '5px 15px' }} /> Report Administrator
        											</Button>
																</Dropdown.Item>}
															</Dropdown.Menu>
														</Dropdown>
													</Menu.Menu>
												</Grid.Column>
											</Grid.Row>
										</Container >
									</div>
								</Menu>
							} */}
						</div>
						:
						<div>
							{
								props.keyword === "AmenityService" &&
								<Menu secondary fixed='top' id="headerStyle" style={{ height: '70px' }} >
									<div style={{ width: '100%', margin: 0 }}>
										<Container style={{ position: 'relative' }}>
											<Grid style={{ margin: 0, padding: 0 }} >
												<Grid.Row style={{ display: 'inline-flex', padding: 0 }}>
													<Grid.Column style={{ padding: 0 }} width={4}>
														<Menu.Item as={Link} to='/' style={{ padding: '5px', margin: 0 }}>
															<Image
																size='tiny'
																src='/assets/images/logo_01.png'
																style={{ height: '45px', width: 'auto' }}
															/>
														</Menu.Item>
													</Grid.Column>
													<Grid.Column tablet={8} mobile={7} computer={8} >
														<h1 style={{ color: "white", textAlign: "center", marginTop: '13px' }}>{props.moduleName}</h1>
													</Grid.Column>
													<Grid.Column tablet={4} mobile={5} computer={4} textAlign="left">
														<span style={{ color: "white", fontSize: "20px", fontWeight: "bold", display: 'block', marginTop: '5px' }}>Floor</span>
														<Dropdown
															placeholder='Select Floor'
															selection
															compact
															name='floor'
															// defaultValue={props.default[0].value}
															value={props.default}
															options={props.floorSelect}
															onChange={props.handleChange}
															style={{ width: "100px" }} />
													</Grid.Column>
												</Grid.Row>
											</Grid>
										</Container >
									</div>
								</Menu>
							}
						</div>
				}

			</div >
		)
	}
}

export default compose(
	withRouter,
	connect(
		(state, props) => ({
			setting: getSettings(state),
			isLoggedIn: getIsLoggedIn(state),
			userInfo: getUserInfo(state),
			isLoading: getIsLoading(state),
			hasError: getHasError(state),
			hasSendReport: getHasSendReport(state),
		}),
		(dispatch, props) => ({
			logout() {
				dispatch(logout())
				props.history.push(`/login`)
			},
			loadSetting() {
				dispatch(findDefaultSetting())
			},
			clearStateFormSearchName() {
				dispatch(clearStateFormSearchName())
			},
			sendReport(body) {
				dispatch(sendReport(body))
			},
		})
	),
	lifecycle({
		componentDidMount() {
			if (this.props.setting.length === 0)
				this.props.loadSetting()
		}
	}),
	// branch(props => props.isLoading, renderComponent(Loading)),
	branch(props => props.hasError, renderComponent(ErrorMessage))

)(Header)


// WEBPACK FOOTER //
// ./src/features/ui/components/Header.js